<div *ngIf="activity" class="activity">
  <div class="activity--item" [ngClass]="{'stage': activity.type_cours === typeCours.stage}">
    <div class="activity--item--options">
      <span *ngIf="activity.type_cours === typeCours.cours" class="activity--item--options-option">{{planningSvc.displayActivityDate(activity)}}</span>
      <span *ngIf="activity.type_cours === typeCours.stage" class="activity--item--options-option">{{planningSvc.displayActivityDate(activity)}}</span>
      <span class="activity--item--options-option">{{activity?.places_disponibles || 0}} place(s)</span>
    </div>
    <div class="activity--item--options sub">
      <span *ngIf="activity?.type_cours" class="activity--item--options-option">{{activity?.type_cours_label}}</span>
      <span *ngIf="activity?.categorie_cours_label" class="activity--item--options-option">{{displayCategorieCours()}}</span>
      <span *ngIf="mySubscription.id > 0 && mySubscription?.state_subscription !== stateSubscription.canceled"
            [ngClass]="['activity--item--options-option','state'+mySubscription?.state_subscription.toString()]">
        Inscription
        <span class="state-value">{{displayState(mySubscription.state_subscription)}}</span>
      </span>
    </div>
    <div class="activity--item--content">
      <div class="activity--item--content--picture">
        <span class="activity--item--picture--inner">{{activity.activite_obj.libelle[0]}}</span>
      </div>
      <div class="activity--item--content--label">
        {{limitContent(activity.libelle, 100)}}
      </div>
    </div>
    <div class="activity--item--options">
      <button mat-raised-button type="button" (click)="openActivity()">
       Détail et inscription</button>
    </div>
  </div>
</div>
